import React, { useState, useEffect } from 'react';
import logo from '../../../assets/images/logo.png';

import moneywave from '../../../assets/images/moneywave.svg';
import burgerIcon from '../../../assets/images/burger-icon.svg';
import closeIcon from '../../../assets/images/close-icon.svg';
import arrowTopRightIcon from '../../../assets/images/arrow_top_right.svg';
import phone from '../../../assets/images/phone.svg'
import lock from '../../../assets/images/lock.svg';
import hide from '../../../assets/images/hide.svg';

import './index.css';
import { Button, Col, Row, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Input from 'react-phone-number-input/input';

import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { DEV_API, SPORTS_CATEGORY, URL } from '../../../const/index.js';
import SideMenu from '../../../components/SideMenu.js';
import { SPORT_ADD, USER_UPDATE } from "../../../store/actionTypes.js";
import Template from "../Template.js"
import { updateUserAct } from '../../../store/actions/userAction.js';

const ActiveSports = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({ ...user, password: '' })
  const [saveStatus, setSaveStatus] = useState(false);

  useEffect(() => {
    axios.get(`${DEV_API}/api/user`, {
      params: {
        _id: user._id,
      }
    }).then((response) => {
      if (response.data.success) {
        console.log(response.data.result, 'userdata')
        dispatch({ type: USER_UPDATE, payload: { user: response.data.result } });
        setFormData({ ...response.data.result, password: '' })
      }
    });
  }, [])

  const handleChange = (e, prop) => {
    let inputData = { ...formData }
    inputData[prop] = e && e.target ? e.target.value : e;
    setFormData(inputData);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    // dispatch(updateUserAct({
    //   search: { _id: user._id },
    //   modify: {
    //     name: formData.name,
    //     balance: formData.balance,
    //     creditLimit: formData.creditLimit,
    //     email: formData.email,
    //     password: formData.password
    //   }
    // }));
    try {
      const response = await axios.put(`${DEV_API}/api/users`, {
        search: { _id: user._id },
        modify: {
          name: formData.name,
          balance: formData.balance,
          creditLimit: formData.creditLimit,
          email: formData.email,
          password: formData.password
        }
      });

      if (response.data.success) {
        dispatch({ type: USER_UPDATE, payload: { user: response.data.result } });
        setSaveStatus(true);
      } else {
        toast(response.data.message);
      }
    } catch (error) {
      // dispatch({ type: AUTH_FAILURE, payload: error.message });
      toast(error.message)
    }
    // navigate('/login')
  };

  const backUpdateMode = () => {
    setSaveStatus(false)
  }
  // console.log(formData, 'formdata')
  return (
    <>
      <Template>
        <div className='screen-2-section'>
          <div className='screen-2-content'>
            <div className='screen-top-part'>
              <div className='logo-part'>
                <Link to="/">
                  <img src={logo} alt="logo" className='img-fluid' />
                </Link>
              </div>
              <span className='screen-title'>My Account</span>
            </div>
            <div className='screen-2-centerpart'>
              {/* <span className='screen-purple-glow-title'>Pick a Game</span> */}
              <div className='screen-form' style={{ margin: 0 }}>
                <Form>
                  <Form.Group controlId="formGroupPassword" className="form-group d-flex align-items-center mb-3">
                    <Form.Label className="me-3" style={{ minWidth: '100px', color: 'white' }}>
                      Username
                    </Form.Label>
                    <Form.Control
                      type="text"
                      style={{ padding: '12px 20px' }}
                      placeholder="Username"
                      onChange={(e) => handleChange(e, 'name')}
                      value={formData['name']}
                    />
                  </Form.Group>
                  <Form.Group controlId="formGroupPassword" className="form-group d-flex align-items-center mb-3">
                    <Form.Label className="me-3" style={{ minWidth: '100px', color: 'white' }}>
                      Balance
                    </Form.Label>
                    <Form.Control
                      type="number"
                      style={{ padding: '12px 20px', opacity: 0.6 }}
                      placeholder="Balance"
                      // onChange={(e) => handleChange(e, 'balance')}
                      disabled
                      value={formData['balance']}
                    />
                  </Form.Group>
                  <Form.Group controlId="formGroupPassword" className="form-group d-flex align-items-center mb-3">
                    <Form.Label className="me-3" style={{ minWidth: '100px', color: 'white' }}>
                      Credit Limit
                    </Form.Label>
                    <Form.Control
                      type="text"
                      style={{ padding: '12px 20px', opacity: 0.6 }}
                      placeholder="CreditLimit"
                      // onChange={(e) => handleChange(e, 'creditLimit')}
                      disabled
                      value={formData['creditLimit']}
                    />
                  </Form.Group>
                  <Form.Group controlId="formGroupEmail" className="form-group d-flex align-items-center mb-3">
                    <Form.Label className="me-3" style={{ minWidth: '100px', color: 'white' }}>
                      Phone
                    </Form.Label>
                    <Input
                      country="US"
                      international
                      withCountryCallingCode
                      value={formData['email']}
                      className="form-control"
                      style={{ padding: '12px 20px' }}
                      onChange={(e) => handleChange(e, 'email')}
                      placeholder="Phone Number"
                    />
                  </Form.Group>
                  <Form.Group controlId="formGroupPassword" className="form-group d-flex align-items-center mb-3">
                    <Form.Label className="me-3" style={{ minWidth: '100px', color: 'white' }}>
                      Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      style={{ padding: '12px 20px' }}
                      placeholder="Password"
                      onChange={(e) => handleChange(e, 'password')}
                      value={formData['password']}
                    />
                  </Form.Group>
                  <Button type="submit" className='sign-in-btn' style={{ ...saveStatus && { backgroundColor: 'black', color: 'yellow' } }} onClick={saveStatus ? backUpdateMode : handleSubmit}>{saveStatus ? 'Saved' : 'Update'}</Button>
                </Form>
              </div>
              <div className='screen-2-center-block'>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
};

export default ActiveSports;
